import React from 'react';
import { useAtomValue } from 'jotai';
import { userBranchesAtom, selectedBranchAtom } from '../../../Atoms';
import PageWrapper from '../../../Components/Paper/PageWrapper';
import { CALL_STANDARD_FILTERS } from '../../../Helpers/Filters/constants';
import getDefaultColumns from '../../../Components/ContactListWrapper/utils/getDefaultColumns';
import DateStepper from './DateStepper';

const BirthdaysPage = function BirthdaysPage(props) {
  const userBranches = useAtomValue(userBranchesAtom);
  const selectedBranch = useAtomValue(selectedBranchAtom) || {};

  return (
    <PageWrapper
      sectionSubName={<DateStepper />}
      columns={getDefaultColumns(userBranches, selectedBranch)}
      statsTabs={['DAILY', 'MONTHLY']}
      apiType="BirthDay"
      searchBoxFilters={['fullNameSearch', 'fiscalCode', 'mobilePhoneNumber']}
      standardFilters={[
        ...CALL_STANDARD_FILTERS,
        // { keyName: 'inCurrentWave', operator: 'eq' },
      ]}
      {...props}
    />
  );
};

export default BirthdaysPage;
